import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import Element from 'element-ui'
import '@/styles/element-variables.scss' // lang i18n

import '@/styles/index.scss' // global css

import App from '@/App'
import router from '@/router'
import store from '@/store'

import '@/plugins' // 注册插件
import '@/plugins/filters'
import '@/icons' // icon
import '@/router/permission' // permission control
import i18n from '@/lang'
import '@/utils/auth/auth-directive'
import { handleVueError } from './utils/errorHandle'

Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false
handleVueError()

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
